import React, { useState, useEffect, useMemo } from 'react'

import CityProgramView from '../../CityProgramView'
import useGraphQLFetch from '../../../../../../Utils/Hooks/useGraphQLFetch'
import { apiClient } from '../../../../../../Module/API/Client'
import {
  createPromoCampaign,
  getPromoCampaigns,
  updatePromoCampaign,
} from './gql'
import { CITY_PROGRAMS, tableColumnsPromo } from '../../options'

const CityPromoCampaign = ({ cityId }) => {
  const [isActive, setIsActive] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)
  const [maxBudget, setMaxBudget] = useState(0)
  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getPromoCampaigns,
    defaultFetchArgs: { cityId },
    mapResponse: data =>
      data.city.promoCampaigns.nodes.map(item => ({
        ...item,
        currencySign: data.city.country.currencySign,
      })),
    fetchId: 'getPromoCampaigns',
  })

  useEffect(() => {
    if (isLoaded) {
      setIsActive(Boolean(data.find(item => item.isActive)))
    }
  }, [isLoaded])

  const onUpdate = (item, form) => {
    const { bonusAmount, signUpLimit, missionsTrigger, promoCode } = form
    if (
      bonusAmount &&
      Number(bonusAmount.value) &&
      (signUpLimit && Number(signUpLimit.value))
    ) {
      setMaxBudget(bonusAmount.value * signUpLimit.value)
    } else {
      setMaxBudget(0)
    }

    if (
      bonusAmount &&
      bonusAmount.isValid &&
      (signUpLimit && signUpLimit.isValid) &&
      (missionsTrigger && missionsTrigger.isValid) &&
      (promoCode && promoCode.isValid)
    ) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }

  const onSubmit = async (form, isValid) => {
    if (isValid) {
      const { bonusAmount, signUpLimit, missionsTrigger, promoCode } = form

      try {
        await createPromoCampaign({
          cityId: Number(cityId),
          missionsTrigger: Number(missionsTrigger.value),
          bonusAmount: Number(bonusAmount.value),
          promoCode: promoCode.value,
          signUpLimit: Number(signUpLimit.value),
        })

        refetch({ cityId })
      } catch (e) {
        console.error({ e })
      }
    }
  }

  const onToggle = async () => {
    if (isActive) {
      try {
        const activePromoCampaign = data.find(item => item.isActive)
        await updatePromoCampaign({
          id: activePromoCampaign.id,
          isActive: false,
        })
        refetch({ cityId })
        setIsActive(!isActive)
      } catch (e) {
        console.error({ e })
      }
    }
  }

  const exportLink = useMemo(() => {
    return apiClient.getURLOfPromoProgramsCSV(cityId)
  }, [cityId])

  return isLoaded ? (
    <CityProgramView
      onToggle={onToggle}
      exportLink={exportLink}
      tableColumns={tableColumnsPromo}
      tableData={data}
      isActive={isActive}
      programType={CITY_PROGRAMS.PROMO}
      onSubmit={onSubmit}
      onUpdate={onUpdate}
      isDisabled={isDisabled}
      maxBudget={maxBudget}
      cypressId="edit-city-ba-promo-section"
    />
  ) : (
    <div>Loading...</div>
  )
}

export default CityPromoCampaign
